<template>
   <v-select
        :items="['event_group_name', 'event_group_short_name', 'wo_partner_name', 'ShopName']"
        box
        :value="value"
        @change="handleChange"
        :label="label[$i18n.locale]"></v-select>
</template>

<script>
// import { mapGetters } from 'vuex'

export default {
    props: ['value', 'label'],
    components: {
        
    },
	methods: {
        handleChange (e) {
            this.$emit('input', e)
        }
	}
};
</script>
<style>

</style>